<template>
  <section class="mh-quates image-bg home-2-img">
    <div class="img-color-overlay">
      <div class="container">
        <div class="row section-separator">
          <div class="each-quates col-sm-12 col-md-6">
            <h3
              class="wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.2s"
            >
              Interested to Work?
            </h3>
            <p
              class="wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.4s"
            >
              <span
                v-show="
                  $store.getters.getQuote != '' ||
                  typeof $store.getters.getQuote != 'undefined'
                "
                >{{ $store.getters.getQuote }} <br /><br
              /></span>
              If you want to get in touch, talk to me about a project
              collaboration or just say hi, fill up the
              <router-link :to="{ name: 'contact', hash: '#contact' }"
                >contact form</router-link
              >
              below or send an email to
              <a
                :href="`mailto:${$store.getters.getEmail}`"
                v-text="$store.getters.getEmail"
              ></a>
              and let's talk.
            </p>
            <router-link
              :to="{ name: 'contact', hash: '#contact' }"
              class="btn btn-fill wow fadeInUp"
              data-wow-duration="0.8s"
              data-wow-delay="0.5s"
              >Contact</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  //
};
</script>
